var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189_459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 85C65.9721 85 85 65.9721 85 42.5C85 19.0279 65.9721 0 42.5 0C19.0279 0 0 19.0279 0 42.5C0 65.9721 19.0279 85 42.5 85Z",
    fill: "#FFC91B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44446 37.7779L54.9907 83.1332C69.2537 78.7538 80.3187 67.071 83.8263 52.4478L65.3021 33.9207L9.44446 37.7779Z",
    fill: "#D48B07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7105 28.3335H47.27V33.0556C47.27 34.3595 46.2128 35.4167 44.9089 35.4167C43.605 35.4167 42.5478 34.3595 42.5478 33.0556V28.3335H9.44446V37.778L28.1413 46.478C30.9357 47.7782 33.0828 50.1687 34.0407 53.0982C36.5105 60.6529 43.6121 66.1112 51.9923 66.1112C62.5079 66.1112 71.0165 57.5184 70.8794 46.9712C70.7449 36.5913 62.0918 28.3335 51.7105 28.3335Z",
    fill: "#366695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7106 28.3335H51.7059V66.1055C51.8016 66.107 51.8962 66.1112 51.9921 66.1112C62.5077 66.1112 71.0164 57.5184 70.8792 46.9716C70.7449 36.5913 62.0919 28.3335 51.7106 28.3335Z",
    fill: "#273B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9931 56.6668C57.2091 56.6668 61.4376 52.4383 61.4376 47.2223C61.4376 42.0063 57.2091 37.7778 51.9931 37.7778C46.7771 37.7778 42.5486 42.0063 42.5486 47.2223C42.5486 52.4383 46.7771 56.6668 51.9931 56.6668Z",
    fill: "#273B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9923 37.7778C51.8963 37.7778 51.8013 37.7821 51.7061 37.785V56.6593C51.8013 56.6621 51.8963 56.6664 51.9923 56.6664C57.2081 56.6664 61.4367 52.4378 61.4367 47.222C61.4367 42.0061 57.2081 37.7778 51.9923 37.7778Z",
    fill: "#121149"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189_459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityIcon5);
export default __webpack_public_path__ + "static/media/priority_icon_5.82727d5d153722578eb5e939df011c69.svg";
export { ForwardRef as ReactComponent };